import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const CARDS: { to: string; title: string; adminOnly?: boolean }[] = [
  { to: '/jobs', title: 'Jobs' },
  { to: '/blog', title: 'Blog posts' },
  { to: '/services', title: 'Services', adminOnly: true },
  { to: '/team', title: 'Team members', adminOnly: true },
  { to: '/logos', title: 'Partner logos', adminOnly: true },
  { to: '/testimonials/business', title: 'Business testimonials', adminOnly: true },
  { to: '/testimonials/candidate', title: 'Candidate testimonials', adminOnly: true },
  { to: '/users', title: 'Users', adminOnly: true },
  { to: '/settings', title: 'Settings', adminOnly: true },
];

export function Dashboard() {
  const { role } = useAuth();
  const isAdmin = role === 'admin';
  return (
    <>
      <h3 className="fw-bold mb-4">Dashboard</h3>
      <div className="row g-3">
        {CARDS.filter((c) => !c.adminOnly || isAdmin).map((c) => (
          <div className="col-sm-6 col-md-4" key={c.to}>
            <Link to={c.to} className="text-decoration-none">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title text-green">{c.title}</h5>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}
